import instagram from "../../../assets/skiilsLogo/iconLogo/instagram.png";
import x from "../../../assets/skiilsLogo/iconLogo/twitter.png";
import git from "../../../assets/skiilsLogo/iconLogo/github.png";
import linkedin from "../../../assets/skiilsLogo/iconLogo/linkedin.png";
import styles from "./SocialLinks.module.css";

const SocialLinks = () => {
  const socialData = [
    {
      src: instagram,
      alt: "Instagram",
      href: "https://www.instagram.com/vivekshxrma.me/",
    },
    { src: git, alt: "GitHub", href: "https://github.com/Codester06" },
    { src: x, alt: "X", href: "https://x.com/VivekkShxrma" },
    {
      src: linkedin,
      alt: "LinkedIn",
      href: "https://www.linkedin.com/in/vivek-sharma-a6bb2b2b7/",
    },
  ];

  return (
    <div className={styles.container}>
      <p className={styles.socialTitle}>Let's Connect :</p>
      <div className={styles.LinksContainer}>
        {socialData.map((social, index) => (
          <a
            key={index}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            <img
              src={social.src}
              alt={social.alt}
              className={styles.socialIcon}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;
